import React from 'react';
import { motion } from 'framer-motion';
import { truckBrands } from '../data/mockData';

const BrandsSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Nos marques partenaires</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Des pièces d'origine et compatibles pour toutes les grandes marques de poids lourds
          </p>
        </motion.div>

        <motion.div 
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-6 items-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          {truckBrands.map((brand, index) => (
            <motion.div
              key={brand.id}
              className="flex flex-col items-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="w-24 h-24 p-4 bg-gray-100 rounded-full flex items-center justify-center shadow-sm">
                <img 
                  src={brand.logo} 
                  alt={brand.name} 
                  className="w-full h-full object-contain rounded-full"
                />
              </div>
              <p className="mt-3 text-center font-medium">{brand.name}</p>
            </motion.div>
          ))}
        </motion.div>
        
        <motion.div 
          className="mt-16 max-w-4xl mx-auto bg-gradient-to-r from-gray-100 to-white p-6 md:p-8 rounded-2xl shadow-lg"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/3 mb-6 md:mb-0">
              <motion.img 
                src="https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&q=80" 
                alt="Catalogue de pièces" 
                className="w-full h-auto rounded-lg shadow-md"
                whileHover={{ y: -5, boxShadow: "0 10px 20px rgba(0,0,0,0.1)" }}
              />
            </div>
            <div className="md:w-2/3 md:pl-8">
              <h3 className="text-2xl font-bold mb-4">Accédez à notre catalogue complet</h3>
              <p className="text-gray-600 mb-6">
                Plus de 25 000 références disponibles pour tous les modèles de poids lourds. 
                Filtrez par marque, modèle, catégorie ou spécifications techniques pour trouver 
                exactement ce dont vous avez besoin.
              </p>
              <motion.button
                className="bg-[#E60023] text-white px-6 py-3 rounded-md font-medium inline-flex items-center"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <span>Explorer le catalogue</span>
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                </svg>
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default BrandsSection;
